import { Spinner } from '@customerio/pluma-components/react';

export function PushSettingsLoading() {
  return <Spinner p="200" shouldShowLoadingText={true} label="Checking push settings…" />;
}
